import { Component, OnInit, Renderer2, Inject, NgZone } from '@angular/core';
import { AuthenticationService } from '@services/security';
import { LoginUserRequestModel } from "@shared/LoginUserRequestModel";
import { Router, ActivatedRoute } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppConsts } from "@shared/app-consts";
import { RecaptchaService } from '@services/security/recaptcha-service';
import { DOCUMENT } from '@angular/common';
import { EnumAuthenticateState } from '@shared/security/enum-auth-state';
import { safeReturnUrl } from '@shared/security/safe-return-url';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isLoading: boolean = false;
  returnUrl: string;
  loginForm: FormGroup;
  loginError: any = false;
  emailPattern: string = AppConsts.EMAIL_PATTERN;
  submitted: boolean = false;
  rememberMe: any = false;
  public storeUser: LoginUserRequestModel = new LoginUserRequestModel("", "", false);
  submitWithCaptcha = RecaptchaService.submitWithCaptcha;

  constructor(private route: ActivatedRoute, private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    @Inject(DOCUMENT) private _document, private zone: NgZone) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.service.isLoginPage.next(true);
    let email = "";
    const rememberMe = localStorage.getItem(AppConsts.REMEMBER_ME);
    if (rememberMe && rememberMe != null && rememberMe != "")
      this.rememberMe = JSON.parse(rememberMe);

    if (this.rememberMe) {
      email = localStorage.getItem(AppConsts.USER_MAIL);
    }
    this.storeUser = new LoginUserRequestModel(email, "", this.rememberMe);
    this.buildLoginForm();
  }

  get f() { return this.loginForm.controls; }

  ngAfterViewInit() {
  }

  buildLoginForm() {
    this.loginForm = this.formBuilder.group({
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ],
      Password: [
        "",
        Validators.compose([
          Validators.minLength(8),
          Validators.required
        ])
      ],
      RememberMe: [""]
    });

    this.loginForm.controls['Email'].valueChanges.subscribe(value => {
      this.storeUser.Email = value;
    });

    this.loginForm.controls['Password'].valueChanges.subscribe(value => {
      this.storeUser.Password = value;
    });

    this.loginForm.controls['RememberMe'].valueChanges.subscribe(value => {
      this.rememberMe = value;
    });
    this.loginForm.controls['Email'].setValue(this.storeUser.Email);
    this.loginForm.controls['RememberMe'].setValue(this.storeUser.RememberMe);
  }

  handleValidSubmit = (event) =>{
    event.preventDefault();
    this.submitWithCaptcha(this.login.bind(this),event,"submit");
  }

  login($event: MouseEvent, recaptchaToken : string) {
    ($event.target as HTMLButtonElement).disabled = true;
    this.submitted = true;
    this.loginError = false;
    if (this.loginForm.invalid) {
      ($event.target as HTMLButtonElement).disabled = false;
      return;
    }
    this.isLoading = true;
    const isTwoFactorRememberClient = localStorage.getItem(AppConsts.IsTwoFactorRememberClient);
    let user = new LoginUserRequestModel(this.storeUser.Email, btoa(this.storeUser.Password), this.storeUser.RememberMe);
    user.RecaptchaToken = recaptchaToken;
    if (isTwoFactorRememberClient && isTwoFactorRememberClient != null && isTwoFactorRememberClient.toLowerCase() === 'true')
      user.IsTwoFactorRememberClient = true;
    this.service.login(user).subscribe((response: any) => {
      ($event.target as HTMLButtonElement).disabled = false;
      if (response && response != null && !response.IsError) {
        if (response.CnxEtatCompte == EnumAuthenticateState.ChgMDP) {
          const link = response.LinkResetPassword;
          this.zone.runOutsideAngular(() => {
            window.location.href = link;
          });
        }
        if (response.IsTwoFactorRequired) {
          if (user.IsTwoFactorRememberClient)
            this.signIn(response);
          else {
            sessionStorage.setItem(AppConsts.REMEMBER_ME, this.rememberMe);
            sessionStorage.setItem(AppConsts.CRMClientCurrentEmail, this.storeUser.Email);
            this.router.navigate(['login/send-code'], { queryParams: { returnUrl: this.returnUrl } });
          }
        }
        else
          this.signIn(response);
      }
      else {
        ($event.target as HTMLButtonElement).disabled = false;
        this.loginError = true;
      }
      this.isLoading = false;
    }, error => {
      ($event.target as HTMLButtonElement).disabled = false;
      this.loginError = true;
      this.isLoading = false;
    });
    return false;
  }

  signIn(response: any) {
    this.service.isLoginPage.next(false);
    this.service.signIn(response, this.storeUser.Email, this.rememberMe);
    this.router.navigate(['']);
    const returnUrl = safeReturnUrl(this.returnUrl);
    if (returnUrl != '/') {
      this.zone.runOutsideAngular(() => {
        window.location.href = returnUrl;
      });
    }
  }

  showResponse(response) {
    //call to a backend to verify against recaptcha with private key
  }

  redirectToLostPassword() {
    this.router.navigate['/lostpassword'];
  }
}
